var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 42C32.672 42 32 41.328 32 40.5V22H35V40.5C35 41.328 34.328 42 33.5 42Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 38C16.895 38 16 38.895 16 40C16 41.105 16.895 42 18 42C19.105 42 20 41.105 20 40C20 38.895 19.105 38 18 38Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H18H16.992L16 39.826L18 40L19.992 39.826L19 17Z",
    fill: "#0078D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6C21.448 6 21 6.448 21 7V15C21 15.553 20.552 16 20 16C19.448 16 19 15.553 19 15V7C19 6.448 18.552 6 18 6C17.448 6 17 6.448 17 7V15C17 15.553 16.552 16 16 16C15.448 16 15 15.553 15 15V7C15 6.448 14.552 6 14 6C13.448 6 13 6.448 13 7V18C13 20.209 14.791 22 17 22H19C21.209 22 23 20.209 23 18V7C23 6.448 22.552 6 22 6Z",
    fill: "#199BE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26H35V6.013H34.263C30.824 6.013 28 9.486 28 13.714V25C28 25.552 28.448 26 29 26Z",
    fill: "#199BE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunch);
export default __webpack_public_path__ + "static/media/lunch.d78f64f9804a513c0e8cce6a6600652a.svg";
export { ForwardRef as ReactComponent };